import './utils/tracer.js';
import React, {useCallback, useEffect} from 'react';
import {io} from 'socket.io-client';
import {
	BrowserRouter as Router,
	Switch,
	Route,
} from 'react-router-dom';
import CreditCard from './jsx/screens/CreditCard/CreditCard.js';
import './sass/style.scss';
import {PROJECT} from './constants.js';

const {
	REACT_APP_API_ENDPOINT,
	REACT_APP_SOCKET_URL_PATH = '/socket.io',
	REACT_APP_API_ROUTE_PREFIX = '',
} = process.env;
console.debug({REACT_APP_API_ENDPOINT, REACT_APP_SOCKET_URL_PATH, REACT_APP_API_ROUTE_PREFIX});

window.socket = io(REACT_APP_API_ENDPOINT, {
	reconnection: true,
	path: REACT_APP_API_ROUTE_PREFIX + REACT_APP_SOCKET_URL_PATH,
});
window.addEventListener('focus', () => window.socket.connect());

/**
 *
 */
function App() {
	const listenPostMessage = useCallback(event => {
		const customCssUrlParameter = event.data.data;
		if (!customCssUrlParameter) {
			return;
		}

		const head = document.querySelector('head');
		const link = document.createElement('link');
		link.href = customCssUrlParameter;
		link.rel = 'stylesheet';
		link.type = 'text/css';
		head.append(link);
	}, []);

	useEffect(() => {
		window.addEventListener('message', listenPostMessage);
		return () => {
			window.removeEventListener('message', listenPostMessage);
		};
	}, [listenPostMessage]);

	useEffect(() => {
		setTimeout(() => {
			const {connected = false} = window.socket || {};
			console[connected ? 'log' : 'error'](`socket.io status is: ${connected ? 'connected' : 'disconnected'}`);
		}, 1000);
	}, [null]);

	return (
		<div className='App'>
			<Router basename={PROJECT.APP.BASENAME}>
				<Switch>
					<Route exact path='/'>
						<CreditCard/>
					</Route>
					<Route path='/plugin'>
						<CreditCard route='plugin' showBack={false}/>
					</Route>
					<Route path='/gamapay-web'>
						<CreditCard route='gamapay-web'/>
					</Route>
				</Switch>
			</Router>
		</div>
	);
}

export default App;
